import React from "react";

const TabWrapper = ({ vals }) => {
  const { name, description, attraction } = vals;
  return (
    <>
      <section className="hotel-list-tabs my-5">
        <div className="tabs-wrapper">
          <div className="container">
            <ul
              className="nav nav-tabs border-0 justify-content-between"
              role="tablist"
            >
              <li className="nav-item">
                <a
                  className="nav-link active"
                  data-bs-toggle="tab"
                  href="#Overview"
                >
                  Overview
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="tab-content">
          <div id="Overview" className="container tab-pane active">
            <h2 className="title">About {name}</h2>
            <div dangerouslySetInnerHTML={{ __html: description }} />
          </div>
        </div>

        <div className="tab-content">
          <div id="attraction" className="attraction container tab-pane active">
            <h2 className="title">Attraction Near {name}</h2>
            <div dangerouslySetInnerHTML={{ __html: attraction }} />
          </div>
        </div>
      </section>
    </>
  );
};

export default TabWrapper;
